<template>
  <div class="leifeng-shop">
    <el-card class="main-card">
      <div class="header-section">
        <h2 class="page-title">
          <i class="el-icon-s-shop title-icon"></i>
          雷锋e站店铺管理
        </h2>
      </div>
      
      <div class="content-section">
        <!-- 搜索栏 -->
        <div class="search-box">
          <el-row type="flex" :gutter="12" class="search-row">
            <el-col :span="6">
              <el-row type="flex" :gutter="12">
                <el-col :span="24">
                  <el-input
                    size="small"
                    clearable
                    placeholder="请输入店铺名称或公司名称"
                    prefix-icon="el-icon-search"
                    v-model="query.keyword"
                    @keyup.enter.native="getList"
                    class="search-input"
                  />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <div class="search-buttons search-buttons-right">
                <el-button type="primary" size="small" @click="getList">查询</el-button>
                <el-button size="small" @click="resetQuery">重置</el-button>
              </div>
            </el-col>
          </el-row>
          
          <!-- 状态筛选 -->
          <div class="filter-section">
            <span class="filter-label">店铺状态：</span>
            <el-radio-group v-model="query.states" size="small" @change="handleStatusChange" class="filter-radio">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">已通过</el-radio-button>
              <el-radio-button label="2">待审核</el-radio-button>
              <el-radio-button label="3">已拒绝</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        
        <!-- 店铺列表 -->
        <div class="table-wrapper">
          <div class="table-container" v-loading="tableLoading">
            <el-table :data="shopList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="name" label="店铺名称" min-width="150"></el-table-column>
              <el-table-column prop="company_name" label="公司名称" min-width="150"></el-table-column>
              <el-table-column prop="public_service" label="公益服务" min-width="200"></el-table-column>
              <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.states === 1" size="small" type="success">已通过</el-tag>
                  <el-tag v-else-if="scope.row.states === 2" size="small" type="warning">待审核</el-tag>
                  <el-tag v-else-if="scope.row.states === 3" size="small" type="danger">已拒绝</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="add_time" label="申请时间" width="180"></el-table-column>
              <el-table-column label="操作" width="300" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" icon="el-icon-view" @click="openDetail(scope.row)">详情</el-button>
                  <el-button size="small" icon="el-icon-picture" @click="openBannerDialog(scope.row)">编辑轮播图</el-button>
                  <el-button
                    v-if="scope.row.states === 2"
                    size="small"
                    type="success"
                    icon="el-icon-check"
                    @click="openApproveDialog(scope.row)"
                  >
                    通过
                  </el-button>
                  <el-button
                    v-if="scope.row.states === 2"
                    size="small"
                    type="danger"
                    icon="el-icon-close"
                    @click="openRejectDialog(scope.row)"
                  >
                    拒绝
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <!-- 空状态 -->
            <div v-if="shopList.length === 0 && !tableLoading" class="empty-state">
              <i class="el-icon-s-shop empty-icon"></i>
              <p class="empty-text">暂无店铺数据</p>
            </div>
            
            <!-- 分页 -->
            <el-pagination
              class="pagination-box"
              :pager-count="7"
              @current-change="pageChange"
              @size-change="sizeChange"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="query.limit"
              background
              :total="exp.total"
            />
          </div>
        </div>
      </div>
    </el-card>
    
    <!-- 店铺详情弹窗 -->
    <el-dialog
      v-dialogDrag
      title="店铺详情"
      :visible.sync="detailVisible"
      width="800px"
      class="detail-dialog"
    >
      <div v-if="detailInfo" class="detail-content">
        <el-descriptions :column="2" border size="small" class="detail-table">
          <el-descriptions-item label="店铺ID">{{ detailInfo.id }}</el-descriptions-item>
          <el-descriptions-item label="店铺状态">
            <el-tag v-if="detailInfo.states === 1" size="small" type="success">已通过</el-tag>
            <el-tag v-else-if="detailInfo.states === 2" size="small" type="warning">待审核</el-tag>
            <el-tag v-else-if="detailInfo.states === 3" size="small" type="danger">已拒绝</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="店铺名称">{{ detailInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="公司名称">{{ detailInfo.company_name }}</el-descriptions-item>
          <el-descriptions-item label="公益服务" :span="2">{{ detailInfo.public_service || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请时间">{{ detailInfo.add_time }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ detailInfo.audit_time || '-' }}</el-descriptions-item>
        </el-descriptions>
        
        <!-- 审核备注 -->
        <div v-if="detailInfo.audit_remark" class="audit-remark">
          <h4>审核备注</h4>
          <p>{{ detailInfo.audit_remark }}</p>
        </div>
        
        <!-- 其他材料 -->
        <div v-if="detailInfo.other_materials && detailInfo.other_materials.length > 0" class="other-materials">
          <h4>其他材料</h4>
          <div class="material-list">
            <div v-for="(material, index) in detailInfo.other_materials" :key="index" class="material-item">
              <span>{{ material }}</span>
            </div>
          </div>
        </div>
        
        <!-- 轮播图展示 -->
        <div v-if="detailInfo.banners && detailInfo.banners.length > 0" class="banners-section">
          <h4>店铺轮播图</h4>
          <div class="banners-list">
            <div v-for="(banner, index) in detailInfo.banners" :key="index" class="banner-item">
              <img v-if="banner.url" :src="banner.url" class="banner-preview" alt="轮播图" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 编辑轮播图弹窗 -->
    <el-dialog
      v-dialogDrag
      title="编辑轮播图"
      :visible.sync="bannerVisible"
      width="700px"
      class="banner-dialog"
    >
      <div class="banner-edit-content">
        <div class="add-banner-btn">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addBanner">添加轮播图</el-button>
        </div>
        <div v-if="bannerForm.banners.length === 0" class="empty-banners">
          <p>暂无轮播图，请点击上方按钮添加</p>
        </div>
        <div v-else class="banners-edit-list">
          <div v-for="(banner, index) in bannerForm.banners" :key="index" class="banner-edit-item">
            <div class="banner-index">{{ index + 1 }}</div>
            <div class="banner-upload-wrapper">
              <el-upload
                :headers="token"
                accept=".jpg,.png,.jpeg,.gif"
                :on-remove="(file, fileList) => bannerRemove(file, fileList, index)"
                :limit="1"
                :action="imgUrl"
                list-type="picture"
                :on-exceed="exceed"
                :on-success="(response, file, fileList) => bannerSuccess(response, file, fileList, index)"
                name="image"
                :file-list="bannerFileLists[index] || []"
              >
                <el-button size="small" type="primary">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg/gif文件</div>
              </el-upload>
            </div>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="removeBanner(index)"></el-button>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bannerVisible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveBanners">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 审核通过弹窗 -->
    <el-dialog
      v-dialogDrag
      title="审核通过"
      :visible.sync="approveVisible"
      width="500px"
      class="approve-dialog"
    >
      <el-form :model="approveForm" label-width="100px" class="approve-form">
        <el-form-item label="审核备注">
          <el-input
            v-model="approveForm.audit_remark"
            type="textarea"
            :rows="4"
            placeholder="请输入审核备注（选填）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveVisible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="confirmApprove">确认通过</el-button>
      </div>
    </el-dialog>
    
    <!-- 审核拒绝弹窗 -->
    <el-dialog
      v-dialogDrag
      title="审核拒绝"
      :visible.sync="rejectVisible"
      width="500px"
      class="reject-dialog"
    >
      <el-form :model="rejectForm" label-width="100px" class="reject-form">
        <el-form-item label="审核备注">
          <el-input
            v-model="rejectForm.audit_remark"
            type="textarea"
            :rows="4"
            placeholder="请输入审核备注（必填）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" :loading="btnLoading" @click="confirmReject">确认拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  shopList,
  shopDetail,
  shopApprove,
  shopReject,
  detailMerchant,
  setBanners,
} from '@/api/zhiqing/shop.js'

export default {
  name: 'LeifengShopList',
  data() {
    return {
      tableLoading: false,
      exp: { total: 0 },
      btnLoading: false,
      query: {
        page: 1,
        limit: 20,
        keyword: '',
        states: '',
        app_id: 'wx96b8b522907eed46',
      },
      shopList: [],
      detailVisible: false,
      detailInfo: null,
      approveVisible: false,
      approveForm: {
        id: '',
        audit_remark: '',
        app_id: 'wx96b8b522907eed46',
      },
      rejectVisible: false,
      rejectForm: {
        id: '',
        audit_remark: '',
        app_id: 'wx96b8b522907eed46',
      },
      bannerVisible: false,
      bannerForm: {
        id: '',
        banners: [],
      },
      bannerFileLists: [],
      token: {
        "Accept-Token": window.sessionStorage.getItem("token"),
      },
    }
  },
  computed: {
    imgUrl() {
      return 'https://erp.campgrounds.cn/admin/edu_youth_farm/uploadImage';
    },
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.tableLoading = true
      try {
        const { data: res } = await shopList(this.query)
        console.log('店铺列表完整返回:', res)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.shopList = res.data.list || res.list || []
          this.exp.total = res.data.total || res.total || this.shopList.length
        } else {
          this.$message.error(res.message || '获取店铺列表失败')
        }
      } catch (error) {
        console.error('获取店铺列表错误:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.tableLoading = false
      }
    },
    pageChange(page) {
      this.query.page = page
      this.getList()
    },
    sizeChange(size) {
      this.query.limit = size
      this.query.page = 1
      this.getList()
    },
    handleStatusChange() {
      this.query.page = 1
      this.getList()
    },
    resetQuery() {
      this.query = {
        page: 1,
        limit: 20,
        keyword: '',
        states: '',
        app_id: 'wx96b8b522907eed46',
      }
      this.getList()
    },
    async openDetail(shop) {
      try {
        const { data: res } = await detailMerchant({ id: shop.id })
        console.log('店铺详情完整返回:', res)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.detailInfo = res.data
          this.detailVisible = true
        } else {
          this.$message.error(res.message || '获取店铺详情失败')
        }
      } catch (error) {
        console.error('获取店铺详情错误:', error)
        this.$message.error('网络错误，请稍后重试')
      }
    },
    openApproveDialog(shop) {
      this.approveForm = {
        id: shop.id,
        audit_remark: '',
        app_id: 'wx96b8b522907eed46',
      }
      this.approveVisible = true
    },
    async confirmApprove() {
      this.btnLoading = true
      try {
        const { data: res } = await shopApprove(this.approveForm)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success('审核通过')
          this.approveVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '审核失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
    openRejectDialog(shop) {
      this.rejectForm = {
        id: shop.id,
        audit_remark: '',
        app_id: 'wx96b8b522907eed46',
      }
      this.rejectVisible = true
    },
    async confirmReject() {
      if (!this.rejectForm.audit_remark.trim()) {
        this.$message.warning('请输入审核备注')
        return
      }
      this.btnLoading = true
      try {
        const { data: res } = await shopReject(this.rejectForm)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success('已拒绝')
          this.rejectVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
    async openBannerDialog(shop) {
      try {
        const { data: res } = await detailMerchant({ id: shop.id })
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.bannerForm = {
            id: shop.id,
            banners: res.data.banners || [],
          }
          // 初始化文件列表
          this.bannerFileLists = (res.data.banners || []).map(banner => [{
            name: 'banner',
            url: banner.url
          }])
          this.bannerVisible = true
        } else {
          this.$message.error(res.message || '获取店铺详情失败')
        }
      } catch (error) {
        console.error('获取店铺详情错误:', error)
        this.$message.error('网络错误，请稍后重试')
      }
    },
    addBanner() {
      this.bannerForm.banners.push({ url: '' })
      this.bannerFileLists.push([])
    },
    removeBanner(index) {
      this.bannerForm.banners.splice(index, 1)
      this.bannerFileLists.splice(index, 1)
    },
    bannerSuccess(response, file, fileList, index) {
      console.log(response)
      this.bannerForm.banners[index].url = response.data.url
      this.$set(this.bannerFileLists, index, fileList)
    },
    bannerRemove(file, fileList, index) {
      this.bannerForm.banners[index].url = ''
      this.$set(this.bannerFileLists, index, [])
    },
    exceed() {
      this.$message({
        message: "数量超出",
        type: "warning",
      })
    },
    async saveBanners() {
      const hasEmptyUrl = this.bannerForm.banners.some(b => !b.url.trim())
      if (hasEmptyUrl) {
        this.$message.warning('请完善所有轮播图')
        return
      }
      this.btnLoading = true
      try {
        const { data: res } = await setBanners({
          id: this.bannerForm.id,
          banners: this.bannerForm.banners,
        })
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success('保存成功')
          this.bannerVisible = false
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style scoped>
.leifeng-shop {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 120px);
}

.main-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

.header-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
  color: #409eff;
}

.content-section {
  background: #fff;
}

.search-box {
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e4e7ed;
}

.search-row {
  margin-bottom: 16px;
}

.search-input {
  transition: all 0.3s;
}

.search-input:hover {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.search-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.search-buttons-right {
  justify-content: flex-end;
}

.filter-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.filter-radio {
  flex: 1;
}

.table-wrapper {
  background: #fff;
  border-radius: 8px;
}

.table-container {
  padding: 10px 0;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.pagination-box {
  margin-top: 24px;
  text-align: center;
  padding: 10px 0;
}

.detail-dialog {
  border-radius: 8px;
}

.detail-content {
  padding: 10px 0;
}

.detail-table {
  margin-top: 10px;
}

.audit-remark {
  margin-top: 20px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.audit-remark h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #303133;
}

.audit-remark p {
  margin: 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.other-materials {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.other-materials h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #303133;
}

.material-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.material-item {
  padding: 6px 12px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  font-size: 13px;
  color: #409eff;
}

.banners-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.banners-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #303133;
}

.banners-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.banner-item {
  width: 200px;
  height: 120px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

.banner-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-dialog {
  border-radius: 8px;
}

.banner-edit-content {
  padding: 10px 0;
}

.add-banner-btn {
  margin-bottom: 16px;
}

.empty-banners {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.banners-edit-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.banner-edit-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.banner-index {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #606266;
  flex-shrink: 0;
  margin-top: 8px;
}

.banner-upload-wrapper {
  flex: 1;
}

.approve-dialog,
.reject-dialog {
  border-radius: 8px;
}

.approve-form,
.reject-form {
  padding: 10px 0;
}

.dialog-footer {
  text-align: center;
}
</style>